// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__36cMa","title":"Images45_title__10iba","images":"Images45_images__fNfgJ"};